import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Profile = lazy(() => import("@/pages/Profile"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/profile")({
  component: () => (
    <ProtectedRoute>
      <Profile />
    </ProtectedRoute>
  ),
});
